module.exports = __webpack_public_path__ + "img/line4.4f1bacd7.svg";